// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","inner":"footer_inner__Nf8Qj","brand":"footer_brand__T96GV","note":"footer_note__6Aa-g","link":"footer_link__a8fUV"};